<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb3></breadcrumb3>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>

                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>

                <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile " v-else>
                  <!-- <div>
                    <h3 class="mb-2 mt-2">Schedule Timings </h3>
                  </div> -->
                  
                  <!-- Basic Information -->
                  <div class="card mt-2 ml-md-4" id="shedule_container" style="border: none;">
                      <div class="row">
                        <div class="col-md-12 col-md-12">
                          <div class="submit-section text-left">
                            <router-link to="/doctor/new-schedule-timings">
                              <button class="btn btn-primary btn-sm">
                                Add New Schedule
                              </button>
                            </router-link>
                          </div>
                        </div>
                    </div>
                    <div>
                      <table class="table responsive mt-3">
                        <thead>
                          <tr>
                            <th scope="col" class="text-left" style="background-color: #F8F8F8;">Hospital</th>
                            <th scope="col" class="text-left" style="background-color: #F8F8F8;">City</th>
                            <th scope="col" class="text-left" style="background-color: #F8F8F8;">Charges</th>
                            <th scope="col" class="text-left" style="background-color: #F8F8F8;">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in practitioner_schedule" :key="index" v-if="shouldShowRow(index)">
                            <td>
                              {{ item.hospital_name }}
                            </td>
                            <td>{{ item.city }}</td>
                            <td>{{ item.fees }}</td>
                            <td>
                              <div class="table-action">
                                <a class="btn btn-sm bg-info-light" @click="editSchduleTiming(item.name)">
                                  <i class="fas fa-edit"></i> Edit</a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <h5 v-if="practitioner_schedule.length === 0 && !showspinner
                        " class="No_data">
                        No Schedule List Found
                      </h5>

                    </div>
                  </div>
                  <!-- /Basic Information -->
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
export default {
  data() {
    return {
      associated_hospitals: [{ hospital: "", city: "" }],
      showspinner: true,
      practitioner_schedule: [],
      current: 1,
      paginate: 7,
    };
  },

  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  methods: {

        /* Get Doctor Profile Information */
        get_doctor_details() {
      const params = new URLSearchParams();
      params.append("name", this.user_id);
      CommonApi.get_data("sahaj.api.get_doctor_details", params).then((res) => {
        this.showspinner = false;
        if (res && res.data && res.status_code === 200) {
          this.associated_hospitals = [];
          res.data.associated_hospitals.map((item) =>
            this.associated_hospitals.push({
              hospital: item.hospital,
              city: item.city,
            })
          );
          if (this.associated_hospitals.length === 0) {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please define Associated Hospital first in the Profile",
            showConfirmButton: true,
          }).then(() => {
            this.$router.push(`/doctor/profile-settings`);
          });
        } else {
          // If associated_hospitals is not empty, proceed with getting cities
          this.get_cities();
        }
        }
      });
    },


    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    shouldShowRow(index) {
      const startIndex = (this.current - 1) * this.paginate;
      const endIndex = startIndex + this.paginate;
      return index >= startIndex && index < endIndex;
    },

    previousPage() {
      if (this.current > 1) {
        this.current--;
      }
    },

    nextPage() {
      const maxPage = Math.ceil(this.practitioner_schedule.length / this.paginate);
      if (this.current < maxPage) {
        this.current++;
      }
    },
    updateCurrent(i) {
      this.current = i;
      document.getElementById("shedule_container").scrollIntoView();
    },

    /* Get All Practitioner Schedule  */
    async get_schedule_list_vb() {
      const params = new URLSearchParams();
      params.append("healthcare_practitioner", this.user_id);
      await CommonApi.get_data(
        "sahaj.appointment.get_schedule_list_vb",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.practitioner_schedule = res.data;
          this.paginate_total = Math.ceil(
            this.practitioner_schedule.length / this.paginate
          );
        }
      });
    },

    editSchduleTiming(id) {
      this.$router.push(`/doctor/edit-schedule-timings/${id}`);
    },
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_schedule_list_vb();
    this.get_doctor_details();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/ScheduleTimings.vue